// import '@/utils/polyfill.utils'

import { ExchangeClient, HttpTransport, InfoClient, SubscriptionClient, WebSocketTransport } from '@nktkas/hyperliquid'
import { useMemo } from 'react'


const httpTransport = new HttpTransport()
const infoClient = new InfoClient({ transport: httpTransport })
const wsTransport = new WebSocketTransport()
const subsClient = new SubscriptionClient({
  transport: wsTransport,
})

export function getInfoClient() {
  return infoClient
}
export function getSubsClient() {
  return subsClient
}
